module.exports = __webpack_public_path__ + "static/media/12.e332c866.png";